import { z } from 'zod';
import { LLMBlockSelectionSchema } from './data-sources.schema';

/**
 * Shared schema for sync operations across all third-party integrations
 * (TopDesk, Sharepoint, Rompslomp, etc.)
 */
export const SyncBodySchema = z.object({
  label: z.string().optional(),
  sharedWithCompanyIds: z.array(z.string()).optional(),
  autoTraining: z.boolean().optional(),
  autoInclude: z.boolean().optional(),
  folderId: z.string().optional(),
  expiryDate: z.string().optional(),
  selectedLLMBlocks: z.array(LLMBlockSelectionSchema).optional(),
});

export type SyncBodyDTO = z.infer<typeof SyncBodySchema>;
